import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useTranslate from '@root/core/hooks/useTranslate';
import { Divider, Radio, Table } from 'antd';
// import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// import buskSeller from "../services/buskSeller";
import type { ColumnsType, TableProps } from 'antd/es/table';

interface Props {
  rowData: any;
  sort: boolean;
  loading: boolean;
  total: number;
  selectedRow: React.Key[];
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePage: Function;
  page: number;
  setSort: React.Dispatch<React.SetStateAction<boolean>>;
}

const WarehouseTable = ({
  loading,
  rowData,
  total,
  setSelectedRow,
  selectedRow,
  sort,
  handleChangePage,
  page,
  setSort
}: Props) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRow(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRow,
    onChange: onSelectChange
  };

  const history = useHistory();

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no'
    },
    {
      title: '물류센터명',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '아이디',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: '국가',
      dataIndex: 'countryName',
      key: 'countryName'
    },
    {
      title: '페이팔 계정 등록',
      dataIndex: 'paypalAccount',
      key: 'paypalAccount'
    },
    {
      title: '상태',
      dataIndex: 'state',
      key: 'state'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          가입일
          {!sort ? (
            <DownOutlined
              style={{ marginLeft: '1rem' }}
              onClick={() => {
                setSort(true);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '1rem' }}
              onClick={() => setSort(false)}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt',
      key: 'updatedAt'
    }
  ];

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={rowData}
        pagination={{
          pageSize: 10,
          total: total,
          current: page,
          onChange: (newPage) => {
            handleChangePage(newPage);
          }
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: (e) => {
              let selection = window.getSelection();
              if (selection?.type === 'Range') {
                e.preventDefault();
              } else {
                history.push(`/admin/busk/logistic/${record.id}`);
              }
            }
          };
        }}
      />
    </div>
  );
};

export default WarehouseTable;
